<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('bizUser.nickname')" prop="nickname">
                <a-input v-model="queryParam.nickname" :placeholder="$t('bizUser.inputNickname')" allow-clear/>
              </a-form-item>
            </a-col>

            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('bizUser.email')" prop="email">
                <a-input v-model="queryParam.email" :placeholder="$t('bizUser.inputEmail')" allow-clear/>
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('bizUser.isVip')" prop="sex">
                  <a-select :placeholder="$t('bizUser.selectIsVip')" v-model="queryParam.isVip" style="width: 100%" allow-clear>
                    <a-select-option :value="0">{{ $t('bizUser.no') }}</a-select-option>
                    <a-select-option :value="1">{{ $t('bizUser.yes') }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('bizUser.mobile')" prop="mobile">
                  <a-input v-model="queryParam.mobile" :placeholder="$t('bizUser.inputMobile')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 5 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
                                <a @click="toggleAdvanced" style="margin-left: 8px">
                                  {{ advanced ? $t('common.collapse') : $t('common.expand') }}
                                  <a-icon :type="advanced ? 'up' : 'down'"/>
                                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
                <a-button type="primary" @click="handleExport" >
                  <a-icon type="download" />{{ $t('common.export') }}
                </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" style="margin-bottom: 10px;" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :sexOptions="dict.type.sys_user_sex"
        :isNoticeOptions="dict.type.sys_notice_status"
        :statusOptions="dict.type.sys_enable_disable"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >

        <span slot-scope="text, record" slot="operation">
          <a-divider type="vertical" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" >
            <a-icon type="wallet" />{{ $t('bizUser.rechargeCoin') }}
          </a>
        </span>
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex"/>
        </span>
        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice"/>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge :status="record.status == 1 ? 'success' : 'error'" :text="record.status == 1 ? $t('common.enable') : $t('common.disable')" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="vipOverTime" slot-scope="text, record">
          <div v-if="record.isVip== 1">
            {{ parseTime(record.vipOverTime) }}
          </div>
          <div v-else>{{ '-' }}</div>
        </span>

      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUser, listUser, delUser } from '@/api/biz/user'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'User',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'sys_notice_status', 'sys_enable_disable'],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        mobile: null,
        email: null,
        isVip: null,
        nickname: null,
        sex: null,
        invitationCode: null,
        isNotice: null,
        status: null,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  filters: {
  },
  computed: {
    // 表格列配置
    columns() {
      return [
        {
          title: this.$t('table.index'),
          dataIndex: 'index',
          customRender: (text, record, index) => index + 1,
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('bizUser.userId'),
          dataIndex: 'id',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('bizUser.showId'),
          dataIndex: 'showId',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('bizUser.type'),
          dataIndex: 'type',
          width: 100,
          align: 'center',
          customRender: (text) => {
            if(text == 1) {
              return this.$t('bizUser.phone')
            } else if(text == 0) {
              return this.$t('bizUser.emailType')
            }else if(text == 3) {
              return this.$t('bizUser.thirdParty')
            }
          }
        },
        {
          title: this.$t('bizUser.nickname'),
          dataIndex: 'nickname',
          width: 150,
          ellipsis: true,
          align: 'center',
          customRender: function (text) {
            if (text) {
              return text
            } else {
              return '-'
            }
          }
        },
        {
          title: this.$t('bizUser.email'),
          dataIndex: 'email',
          width: 180,
          ellipsis: true,
          align: 'center',
          customRender: function (text,record) {
            if (record.type == 0) {
              return record.email;
            } else {
              return "-";
            }
          }
        },
        {
          title: this.$t('bizUser.areaCode'),
          dataIndex: 'areaCode',
          width: 100,
          align: 'center',
          customRender: function (text,record) {
            if (record.type == 1) {
              return record.areaCode;
            } else {
              return "-";
            }
          }
        },
        {
          title: this.$t('bizUser.mobile'),
          dataIndex: 'mobile',
          width: 140,
          ellipsis: true,
          align: 'center',
          customRender: function (text,record) {
            if (record.type == 1) {
              return record.mobile;
            } else {
              return "-";
            }
          }
        },
        {
          title: this.$t('bizUser.thirdPartyAccount'),
          dataIndex: 'email',
          width: 180,
          ellipsis: true,
          align: 'center',
          customRender: function (text,record) {
            if (record.type == 1) {
              return "-";
            } else if(record.type == 0) {
              return "-";
            } else {
              return record.mobile;
            }
          }
        },
        {
          title: this.$t('bizUser.invitationCode'),
          dataIndex: 'invitationCode',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('bizUser.userStatus'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('bizUser.isVipStatus'),
          dataIndex: 'isVip',
          width: 100,
          align: 'center',
          customRender: (t) => {
            if (t == 0) {
              return this.$t('bizUser.no')
            } else if (t == 1) {
              return this.$t('bizUser.yes')
            }
          }
        },
        {
          title: this.$t('bizUser.vipType'),
          dataIndex: 'vipType',
          width: 120,
          align: 'center',
          customRender: (t, r) => {
            if(r.isVip== 1) {
              if(t == 1) {
                return this.$t('bizUser.weekVip')
              }else if(t == 2) {
                return this.$t('bizUser.monthVip')
              }else if(t == 3) {
                return this.$t('bizUser.yearVip')
              }
            } else {
              return '-';
            }
          }
        },
        {
          title: this.$t('bizUser.vipExpireTime'),
          dataIndex: 'vipOverTime',
          scopedSlots: { customRender: 'vipOverTime' },
          width: 160,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('bizUser.coinCount'),
          dataIndex: 'diamond',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('bizUser.registerTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: 200,
          fixed: 'right',
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  watch: {
  },
  methods: {
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
      pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        mobile: undefined,
        email: undefined,
        nickname: undefined,
        sex: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('common.delete') + '?',
        content: this.$t('common.confirmDeleteContent') + ids,
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('common.deleteSuccess'),
                3
              )
            })
        },
        onCancel () {
          // 取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('common.export') + '?',
        content: this.$t('common.confirmExportContent'),
        onOk () {
          that.download('biz/users/export', {
            ...that.queryParam
          }, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
